import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { analyticsTracker } from "@utils/analytics";

import { useRootAppStore } from "@hooks";
import { Button } from "@components/buttons";
import { BetSlipShare } from "@models";
import { SharedBetSlipActionsTypeEnum } from "@data-types/analytics-tracker/QuickPlayInteractionTypeEnum";
import { BetSlipInteractionTypeEnum } from "@data-types/analytics-tracker/BetSlipInteractionTypeEnum";
import { ChangePageButton } from "@state/quick-play-store/MostPlayedTicketsStore";

export const SharedBetSlipPopupFooter = observer(
	function SharedBetSlipPopupFooter(props: { bet: BetSlipShare }) {
		const { t } = useTranslation("mybets");
		const { quickPlayStore } = useRootAppStore();
		const rootStore = useRootAppStore();
		const { sharedBetSlipStore } = quickPlayStore;

		return (
			<div className="popup__footer popup__footer--bordered">
				<div className="popup__footer__row">
					<Button
						type="button"
						disabled={
							sharedBetSlipStore.betSlipShareDetails
								.isFetchingData
						}
						isLoading={
							sharedBetSlipStore.betSlipShareDetails
								.isFetchingData &&
							sharedBetSlipStore.showLoader ==
								ChangePageButton.PREVIOUS
						}
						onClick={() => {
							sharedBetSlipStore.changePage(
								ChangePageButton.PREVIOUS
							);
						}}
						switchIcon
						loaderClassName="btn--load--primary"
						className="btn--square btn--square--med btn--primary--inverted"
						iconClassName="u-icon--tny u-icon--caret-left"
						iconOnly
					/>

					<Button
						type="button"
						disabled={
							sharedBetSlipStore.betSlipShareDetails
								.isFetchingData
						}
						onClick={() => {
							analyticsTracker.trackBetSlipSharePopupAdd(
								BetSlipInteractionTypeEnum.ChatBetSlipShare
							);
							analyticsTracker.trackQuickPlayInteraction(
								SharedBetSlipActionsTypeEnum.TicketUse
							);
							rootStore.betSlipStore.useBetSlip({
								...props.bet,
							});
							sharedBetSlipStore.deactivatePopup();
						}}
						btnText={t("SHARE.ADD_TO_SLIP")}
						className="btn--med btn--block btn--accent popup__btn--primary"
					/>

					<Button
						type="button"
						disabled={
							sharedBetSlipStore.betSlipShareDetails
								.isFetchingData
						}
						isLoading={
							sharedBetSlipStore.betSlipShareDetails
								.isFetchingData &&
							sharedBetSlipStore.showLoader ==
								ChangePageButton.NEXT
						}
						onClick={() => {
							sharedBetSlipStore.changePage(
								ChangePageButton.NEXT
							);
						}}
						switchIcon
						loaderClassName="btn--load--primary"
						className="btn--square btn--square--med btn--primary--inverted"
						iconClassName="u-icon--tny u-icon--caret-right"
						iconOnly
					/>
				</div>
			</div>
		);
	}
);
